import React, { useEffect } from 'react';
import axios from 'axios';
import BASE_URL from '../config';

// Component to ensure anonymous user ID is created
const EnsureAnonymousUser = () => {
  useEffect(() => {
    const checkAnonymousUserID = async () => {
      try {
        let anonymousUserID = localStorage.getItem('anonymousUserID');
        
        // If no anonymous user ID is found in localStorage
        if (!anonymousUserID) {
          const response = await axios.get(`${BASE_URL}/api/anonymous/`);
          anonymousUserID = response.data.anonymous_user_id;
          localStorage.setItem('anonymousUserID', anonymousUserID);
        }
      } catch (error) {
        console.error('Error fetching or creating anonymous user ID:', error);
      }
    };

    checkAnonymousUserID();
  }, []); // Empty dependency array means this runs once when the component mounts

  return null; // This component does not render anything
};

export default EnsureAnonymousUser;
